// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cds9","colMin":"styles_colMin__3J5T9"};